<template>
    <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
        <h4><strong style="color:#1A0054">Nuevo Plan empresarial</strong></h4>

        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="agregar_plan">
            <h4><strong style="color:#494949">Agregar plan empresarial</strong></h4>
            <small>Completa el formulario para agregar un nuevo super administrador</small>
            <br>
            <div class="row justify-content-center align-items-center">
                <div class="col-sm-12 col-md-6 col-lg-6 align-self-center">
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" v-model="newPlan.name" class="form-control rounded-8 sin-borde"
                                placeholder="Nombre de la licencia" aria-label="Nombre de la licencia" id="plan-name"
                                required />
                            <span class="text-danger" v-if="error.name">El Nombre de la licencia es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group">
                            <label for="plan-users">Número de usuarios disponibles</label>
                            <input type="number" v-model="newPlan.accepted_users" class="form-control rounded-8 sin-borde"
                                placeholder="Número de usuarios disponibles" aria-label="Número de usuarios disponibles" id="plan-users"
                                required />
                            <span class="text-danger" v-if="error.accepted_users">El Número de usuarios disponibles es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4 d-none">
                        <div class="form-group">
                            <input type="number" v-model="newPlan.accepted_routes" class="form-control rounded-8 sin-borde"
                                placeholder="Número de rutas disponibles" aria-label="Número de rutas disponibles" id="plan-users"
                                required />
                            <span class="text-danger" v-if="error.accepted_routes">El Número de rutas disponibles es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4 d-none">
                        <div class="form-group">
                            <input type="number" v-model="newPlan.accepted_courses" class="form-control rounded-8 sin-borde"
                                placeholder="Número total de cursos" aria-label="Número total de cursos" id="plan-users"
                                required />
                            <span class="text-danger" v-if="error.accepted_courses">El Número total de cursos es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="number" v-model="newPlan.digits" class="form-control rounded-8 sin-borde"
                                placeholder="Tiempo de licencia" aria-label="Tiempo de licencia" id="plan-users"
                                required />
                            <span class="text-danger" v-if="error.digits">El Tiempo de licencia es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group">
                            <select v-model="newPlan.typeTime" class="form-control rounded-8 sin-borde">
                                <option value="" selected="selected" disabled>Seleccione el tipo de tiempo</option>
                                <option value="hours">Horas</option>
                                <option value="days">Días</option>
                                <option value="month">Meses</option>
                                <option value="years">Años</option>
                            </select>
                            <span class="text-danger" v-if="error.typeTime">El Tipo de tiempo es un campo
                                obligatorio</span>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="d-flex gap-4 justify-content-end">
                            <button
                                id="add-plan-button"
                                type="button"
                                class="btn btn-primary text-light rounded-8"
                                @click="addPlan()"
                                v-html="btnAddPlan.btnTextAddPlan"
                                :disabled="btnAddPlan.disabledAddPlan"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['get'],
    data() {
        return {
            url: this.get,
            newPlan: {
                name: "",
                accepted_users: "",
                accepted_routes: 10000,
                accepted_courses: 10000,
                digits: null,
                typeTime: '',
            },
            error: [],
            btnAddPlan : {
                btnTextAddPlan : 'Guardar plan',
                disabledAddPlan : false
            }
        }
    },
    methods: {
        addPlan(){
            let context = this;
            context.btnAddPlan.disabledAddPlan = true;
            context.btnAddPlan.btnTextAddPlan = 'Procesando...';
            axios.post(context.url, context.newPlan)
            .then(( res => {
                context.btnAddPlan.disabledAddPlan = false;
                context.btnAddPlan.btnTextAddPlan = "Guardar plan";
                context.newPlan = {
                    name: "",
                    accepted_users: 0,
                    accepted_routes: 10000,
                    accepted_courses: 10000,
                    digits: null,
                    typeTime: '',
                };
                context.error = [];
                this.$swal('Se ha creado exitosamente el plan empresarial');
                context.$emit('updatetable');
            }))
            .catch((err) => {
                context.btnAddPlan.disabledAddPlan = false;
                context.btnAddPlan.btnTextAddPlan = "Guardar plan";
                context.error = err.response.data.errors;
            })
        }
    }
}
</script>
